var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountriesSuppliedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#FF6900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.72 36H38.6667C37.9594 36 37.2811 36.281 36.781 36.781C36.281 37.2811 36 37.9594 36 38.6667V44.72",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 20.4533V22.6666C25.3334 23.7275 25.7548 24.7449 26.5049 25.4951C27.2551 26.2452 28.2725 26.6666 29.3334 26.6666C30.0406 26.6666 30.7189 26.9476 31.219 27.4477C31.7191 27.9478 32 28.6261 32 29.3333C32 30.8 33.2 32 34.6667 32C35.374 32 36.0522 31.719 36.5523 31.2189C37.0524 30.7188 37.3334 30.0406 37.3334 29.3333C37.3334 27.8666 38.5334 26.6666 40 26.6666H44.2267",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 45.2667V40C30.6666 39.2928 30.3857 38.6145 29.8856 38.1144C29.3855 37.6143 28.7072 37.3334 27.9999 37.3334C27.2927 37.3334 26.6144 37.0524 26.1143 36.5523C25.6142 36.0522 25.3333 35.3739 25.3333 34.6667V33.3334C25.3333 32.6261 25.0523 31.9478 24.5522 31.4477C24.0521 30.9476 23.3739 30.6667 22.6666 30.6667H18.7333",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.3334C39.3638 45.3334 45.3333 39.3638 45.3333 32C45.3333 24.6362 39.3638 18.6667 32 18.6667C24.6362 18.6667 18.6666 24.6362 18.6666 32C18.6666 39.3638 24.6362 45.3334 32 45.3334Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountriesSuppliedIcon);
export default __webpack_public_path__ + "static/media/Countries Supplied-icon.85cde8f1fee3c24e655d2e11daa891d0.svg";
export { ForwardRef as ReactComponent };